<template>
	<div>
		<div class="product-list">
			<div v-if="goodsLoading">
				<el-skeleton :loading="goodsLoading" animated>
					<template slot="template">
						<div style="display: flex;">
							<div style="margin-right: 20px;padding: 15px;" v-for="(item,index) in 4" :key="index">
								<el-skeleton-item variant="image" style="width: 200px; height: 200px;" />
								<div style="padding-top: 10px;">
									<el-skeleton-item variant="h3" style="width: 50%;" />
									<div class="product-price">
										<el-skeleton-item variant="text" style="margin-right: 16px;" />
										<el-skeleton-item variant="text" style="width: 30%;" />
									</div>
								</div>
							</div>
						</div>
					</template>
				</el-skeleton>
			</div>
			<div class="product-item" v-for="(product,index) in products" :key="index" @click="handleDetail(product)"
				v-else>
				<div class="product-image" :style="{height:productItemWidth+'px !important'}">
					<img :src="product.small">
				</div>
				<div style="padding: 10px;">
					<div class="product-name" :title="product.goodsName">{{ product.goodsName }}</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div class="product-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ product.price.toFixed(2) }}</span>
						</div>
						<div class="product-sale">
							{{$t('sales')}}：{{ product.buyCount }}
						</div>
					</div>
				</div>
				<!-- 选择货源按钮 -->
				<div class="select-source-btn-container" v-show="isShowBuy">
					<el-button type="danger" size="medium" class="show-buy-btn" @click.stop="selectSource(product)">
						{{ $t('selectThisSource') }}
					</el-button>
				</div>
			</div>

			<div class="nodata" v-if="products.length==0&&!goodsLoading" style="margin-top: 150px;">
				<img src="/icon/common/nodata.png">
				<span>{{$t('noData')}}</span>
			</div>
		</div>
		<div style="display: flex;width: 1200px;justify-content: center;">
			<!-- 加载更多状态 -->
			<div v-if="loadingMore" class="loading-more" style="margin: 30px 0; text-align: center;">
				<i class="el-icon-loading"></i>
				<span>{{$t('dataLoading')}}</span>
			</div>

			<!-- 已加载全部数据 -->
			<div v-if="!hasMore&&products.length>0" class="load-all"
				style="margin: 30px 0; text-align: center; color: #999;">
				{{$t('loadingFinish')}}
			</div>
		</div>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import goodsApi from '@/api/product';
	export default {
		name: 'ProductList',
		props: {
			//是否显示购买按钮
			isShowBuy: {
				type: Boolean,
				default: false
			},
			//商品关键词
			keyword: {
				type: String,
				default: null
			},
			//商家商品分类
			storeCategoryId: {
				type: String,
				default: null
			},
			//商品分类
			categoryId: {
				type: String,
				default: null
			},
			//商家编号
			storeId: {
				type: String,
				default: null
			},
			//品牌
			brand: {
				type: String,
				default: null
			},
			//代购平台
			platform: {
				type: String,
				default: null
			},
			//价格区间
			priceRange: {
				type: String,
				default: null
			},
			//含/不含邮费
			shipping: {
				type: String,
				default: null
			},
			//排序方式
			sortBy: {
				type: String,
				default: null
			},
			//距离顶部像素
			scrollTop: {
				type: Number,
				default: 0
			},
			//调用组件来源,merchat商家，product商品
			source: {
				type: String,
				default: 'product'
			}
		},
		data() {
			return {
				productItemWidth: 0,
				goodsLoading: true, //是否显示骨架
				products: [],
				currencySymbol: '',
				params: {
					pageNumber: 1,
					pageSize: 20
				},
				loadingMore: false, // 加载更多的状态
				hasMore: true, // 是否还有更多数据
				isMounted: false // 组件是否已挂载
			}
		},
		mounted() {
			// 组件挂载后添加滚动事件监听器
			this.isMounted = true;
			window.addEventListener('scroll', this.handleScroll);
			// 组件销毁时移除滚动事件监听器
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
		},
		methods: {
			init() {
				this.products = [];
				this.goodsLoading = true;
				this.params.pageNumber = 1;
				this.hasMore = true;
				this.currencySymbol = storage.getCurrencySymbol();
				window.scrollTo({
					top: this.scrollTop,
					behavior: 'smooth'
				})
				this.getGoodsList();
			},
			async getGoodsList() {
				try {
					var params = {
						...this.params,
						rateCode: storage.getCurrency()
					}
					params.notConvert = true;
					params.sort = this.sortBy;
					params.order = "desc";
					if (this.storeId) {
						params.storeId = this.storeId;
					}
					if (this.source == 'merchant') {
						params.marketEnable = "UPPER";
						params.authFlag = "PASS";
					}
					//商品分类
					if (this.categoryId && this.categoryId != 'all') {
						params.categoryPath = this.categoryId;
					}
					//关键词
					if (this.keyword) {
						params.goodsName = this.keyword;
					}
					//代购平台
					if (this.platform && this.platform != 'all') {
						params.goodsPlatformId = this.platform;
					}
					//价格区间
					if (this.priceRange && this.priceRange != 'all') {
						params.price = this.priceRange;
					}
					//品牌
					if (this.brand && this.brand != 'all') {
						params.brandId = this.brand;
					}
					if (this.storeCategoryId && this.storeCategoryId != 'all') {
						params.storeCategoryPath = this.storeCategoryId;
					}
					//const res = await goodsApi.getStoreGoodsList(params);
					const res = this.source == 'merchant' ? await goodsApi.getStoreGoodsList(params) : await goodsApi
						.getGoodsList(params);
					const products = res.result.records;

					// 检查是否是第一页加载
					if (this.params.pageNumber === 1) {
						// 第一页直接替换数据
						this.products = products;
					} else {
						// 后续页追加数据
						this.products = [...this.products, ...products];
					}

					// 检查是否还有更多数据
					const total = res.result.total;
					if (this.products.length >= total) {
						this.hasMore = false;
					}

					// 重置加载状态
					this.goodsLoading = false;
					this.loadingMore = false;

					// 获取product-item的宽度
					this.$nextTick(() => {
						this.getProductItemWidth();
					});
				} catch (error) {
					console.error('获取商品列表失败:', error);
					if (this.params.pageNumber === 1) {
						this.products = [];
					}
					// 重置加载状态
					this.goodsLoading = false;
					this.loadingMore = false;
				}
			},

			// 加载更多数据
			loadMore() {
				if (this.loadingMore || !this.hasMore || this.goodsLoading) {
					return;
				}

				this.loadingMore = true;
				this.params.pageNumber++;
				this.getGoodsList();
			},

			// 处理滚动事件
			handleScroll() {
				if (!this.isMounted || this.loadingMore || !this.hasMore) {
					return;
				}
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const clientHeight = document.documentElement.clientHeight || window.innerHeight;

				// 当距离底部小于230px时，加载更多数据
				if (scrollHeight - scrollTop - clientHeight < 230) {
					this.loadMore();
				}
			},
			//跳转商品详情页
			handleDetail(row) {
				if (!this.isShowBuy) {
					window.open('/product-detail?goodsId=' + row.id);
				}
			},
			selectSource(product) {
				// 选择货源的处理逻辑
				console.log('选择了货源:', product);
				this.$message.info('选中了这个货源，直接添加到购物车？')
				// 可以在这里添加具体的选择逻辑，比如添加到购物车或发送请求
			},
			// 获取product-item的宽度
			getProductItemWidth() {
				// querySelector只会返回匹配的第一个元素，符合需求
				const productItem = document.querySelector('.product-item');
				if (productItem) {
					// 获取元素的宽度
					this.productItemWidth = productItem.offsetWidth;
				}
			}
		}
	}
</script>

<style scoped>
	.product-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 15px;
		max-width: 1200px;
		margin: 0 auto 25px auto;
	}

	.product-item {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		text-align: center;
		transition: all 0.3s ease;
		position: relative;
		cursor: pointer;
	}

	.product-item:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
	}

	/* 选择货源按钮样式 */
	.select-source-btn-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 2;
		opacity: 0;
		transition: opacity 0.3s ease;
		pointer-events: none;
	}

	.show-buy-btn {
		background-color: #D9001B;
		border-color: #D9001B;
	}

	.product-item:hover .select-source-btn-container {
		opacity: 1;
		pointer-events: auto;
	}

	/* 确保按钮在图片上方显示 */
	.product-image {
		position: relative;
		z-index: 1;
	}

	.product-image {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.product-image img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: transform 0.3s ease;
		border-radius: 8px;
	}

	.product-item:hover .product-image img {
		transform: scale(1.05);
	}

	.product-name {
		font-size: 15px;
		color: #333;
		margin-bottom: 10px;
		height: 40px;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: left;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.product-price {
		font-size: 20px;
		font-weight: bold;
		color: #F59A23;
		text-align: left;
	}

	.product-sale {
		font-size: 14px;
		color: #999;
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 10px;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		margin-left: 10px;
		color: #999;
		font-size: 16px;
	}

	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	/* 已全部加载样式 */
	.load-all {
		font-size: 16px;
		padding: 10px 0;
	}
</style>